export default "__VITE_ASSET__D8qKT$5W__"